var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#FFEBEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1538 12.8462L10.7538 13.2431C10.6615 12.9754 10.6154 12.6846 10.6154 12.3846C10.6154 12.2738 10.6154 12.1538 10.6338 12.0569L10.1538 11.7385L8.76923 12.6615L7.38462 11.7385L6.92308 12.0431V5.92308H13.3846V9.61538C13.7077 9.61538 14.0169 9.67077 14.3077 9.77231V5H6V13.7692L7.38462 12.8462L8.76923 13.7692L10.1538 12.8462ZM12.4615 7.76923V6.84615H7.84615V7.76923H12.4615ZM11.5385 9.61538V8.69231H7.84615V9.61538H11.5385ZM13.3846 11.7385L12.4154 10.7692L11.7692 11.4154L12.7385 12.3846L11.7692 13.3538L12.4154 14L13.3846 13.0308L14.3538 14L15 13.3538L14.0308 12.3846L15 11.4154L14.3538 10.7692L13.3846 11.7385Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelInvoice);
export default __webpack_public_path__ + "static/media/CancelInvoice.6a4e43d0.svg";
export { ForwardRef as ReactComponent };